<template>
    <div class="dropdown filter_item">
        <button class="btn m-r-5 btn-default waves-effect waves-light dropdown-toggle" :class="{'btn-success': bathrooms_touched}" type="button" data-toggle="dropdown">
            Banheiros
        </button>

        <div class="dropdown-menu dropdown-menu-left arrow-dropdown-menu arrow-menu-left dropdown-lg">
            <p class="h5 m-b-15">Banheiros</p>

            <div class="form-group">
                <div class="checkbox checkbox-success">
                    <input type="checkbox" name="bathrooms" id="bathrooms_1" v-model="model" value="1"/>
                    <label for="bathrooms_1">1</label>
                </div>

                <div class="checkbox checkbox-success">
                    <input type="checkbox" name="bathrooms" id="bathrooms_2" v-model="model" value="2"/>
                    <label for="bathrooms_2">2</label>
                </div>

                <div class="checkbox checkbox-success">
                    <input type="checkbox" name="bathrooms" id="bathrooms_3" v-model="model" value="3"/>
                    <label for="bathrooms_3">3</label>
                </div>

                <div class="checkbox checkbox-success">
                    <input type="checkbox" name="bathrooms" id="bathrooms_4" v-model="model" value="4"/>
                    <label for="bathrooms_4">4+</label>
                </div>
            </div>

            <div class="row m-t-30">
                <div class="col-xs-12">
                    <button @click="filter()" class="btn btn-block btn-success">Filtrar</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            model: this.$store.getters.getFilter.bathrooms || [],
        }
    },
    watch: {
        selected_bathrooms: {
            handler(newVal) {
                this.model = newVal;
            }
        }
    },
    computed: {
        selected_bathrooms() {
            return this.$store.getters.getFilter.bathrooms || [];
        },
        bathrooms_touched() {
            return this.selected_bathrooms.length > 0;
        },
    },
    methods: {
        filter() {
            this.$store.commit('setFilter', { bathrooms: this.model });
            this.$emit('filter');
            $(this.$el).find('.dropdown-toggle').dropdown('toggle');
        }
    }
}
</script>

